<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차요금정산</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차요금정산</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <!-- <li class="web">
          <p class="pageTxt">요금사전결제</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납 주차요금">미납 주차요금</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사전결제 안내</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link></li>
            <li><router-link to="/lookup" title="요금 조회/결제">요금 조회/결제</router-link></li>
            <li><router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link></li>
          </ul>
        </li> -->
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사전결제 안내</h3>
        <article class="information">
          <i class="icon prepay"></i>
          <div class="txtArea">
            <strong>주차요금 사전결제란?</strong>
            <p>주차장에서 출차하기 전에 주차요금을 사전결제하여 빠르고 편리하게 주차장을 이용하는 서비스입니다.</p>
            <p>
              PC · 태블릿 · 모바일 기기 등 웹에서 주차요금을 사전결제하고 별도의 절차 없이 빠르게 출차가 가능합니다.
            </p>
          </div>
        </article>
        <article>
          <p class="subTitle">서비스 절차 및 할인</p>
          <!--prepayStep-->
          <div class="prepayStep web">
            <ul>
              <li class="step01">이천시 주차포털<br />사이트에 접속</li>
              <li class="step02">주차요금 사전결제 메뉴에서<br />내 차량번호 조회</li>
              <li class="step03">차량 정보 및 요금 정보 확인 후<br />요금 사전 결제</li>
              <li class="step04">차량 출차</li>
            </ul>
          </div>
          <div class="prepayStep mobile">
            <ul>
              <li class="step01">이천시 주차포털<br />사이트에 접속</li>
              <li class="step02">주차요금 사전결제 메뉴에서<br />내 차량번호 조회</li>
              <li class="step03">차량 출차</li>
              <li class="step04">차량 정보 및 요금 정보 확인 후<br />요금 사전 결제</li>
            </ul>
          </div>
          <!--//prepayStep-->
          <div class="infoBox">
            <ul class="bullet arrowType">
              <li>
                15분 이내 출차 할인 차량은 자동으로 할인 되며, 기타 할인 대상 차량은 이천시시설관리공단 공공사업팀 (031)
                635-2070로 연락하여 확인합니다.
              </li>
              <li>
                할인대상 차량은 경차, 유공자, 장애인, 저공해 차량이며 기타 이천시시 주차장 할인 관련 조례 참조하시기
                바랍니다.
              </li>
            </ul>
            <!--
                                     <a href="https://www.law.go.kr/" target="_blank" class="btn arrow">이천시 주차조례 보러가기</a>
                        -->
          </div>
        </article>
        <article>
          <p class="subTitle">유의사항</p>
          <ul class="bullet dotType">
            <li>
              결제 취소는 불가하오니 타인의 차량을 결제하지 않도록 차량번호를 반드시 확인하고 결제 하시기 바랍니다.
            </li>
            <li>
              결제 후 15분 안에 출차하지 않으면 주차요금이 추가 발생되며, 추가요금은 출차 시 추가로 납부하셔야 합니다.
            </li>
          </ul>
        </article>
        <article class="btnArea">
          <button type="button" class="btn blue" @click="$router.push('/lookup')">주차요금 사전결제</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';

export default {};
</script>
